document.addEventListener('DOMContentLoaded', function() {
    // Run every 50 milliseconds for 10 seconds
    const intervalId = setInterval(() => {
        // Find the selected currency
        const selectedCurrencyElement = document.querySelector('.Popover__ValueList button.is-selected');
        
        // Extract value from the selected element
        const selectedCurrency = selectedCurrencyElement ? selectedCurrencyElement.value : null;

        // Find the shipping notice element by its specific path
        const shippingNotices = document.querySelectorAll(".Cart__ShippingNotice.Text--subdued");

        // Hide the shipping notice if currency is not GBP
        if (selectedCurrency !== 'GBP') {
            shippingNotices.forEach(notice => {
                notice.style.display = 'none';
            });
        }
    }, 5);

    // Stop running after 10 seconds
    setTimeout(() => {
        clearInterval(intervalId);
    }, 10000); // 10 seconds
});
